import React, { Component } from "react";
import { connect } from "react-redux";
import tinycolor from "tinycolor2";
import textSpeech from "../../assets/images/text_to_speech.svg";
import notTextSpeech from "../../assets/images/not_text_to_speech.svg";
import UserInfo from "../../services/user-info";
import ChatUpload from './chat-upload';
import { sendMessage } from "../../actions/message";
import { AngleUpIcon, AngleDownIcon, VolumeHighIcon, VolumeOffIcon, XMarkIcon, CircleHalfStroke } from "../../assets/fontawesome"
import {
  toggleTtsActive,
  toggleMinimize,
  toggleChat,
  toggleOptions,
  closeConversation,
  toggleModal,
  sendEvaluation,
  toggleAttachLoad,
  loadedTTSSound,
  toggleMsgSound,
  toggleAttachAvailable,
  toggleAllowAttachment,
  toggleTtsActive2
} from "../../actions/app";
import { changeToLightTheme, changeToDarkTheme } from "../../actions/theme"

class ChatHeader extends Component {

  buttonSize = "17px";
  buttonSize2 = "17px";
  userInfo = UserInfo.getInfo();
  constructor(props) {
    super(props);

    this.sendEvaluation = this.sendEvaluation.bind(this);
    this.getAttachButton = this.getAttachButton.bind(this);
  }

  handleClose = e => {
    e.stopPropagation();
    if (!this.props.app.conversation || !this.props.app.websocket || !this.props.config.isConversationRatingActive) {
      clearTimeout(this.props.app.counter);
      this.props.closeChat();
      if (this.props.app.minimize)
        this.handleToggleMinimize();

      return false;
    }

    const message = this.props.config.ratingRequestMessage === '' ? "Gostaria de avaliar sua experiência com o chat antes de sair?" : this.props.config.ratingRequestMessage;
    this.props.toggleModal(true, message, this.sendEvaluation, this.props.closeChat);
  }

  sendEvaluation(form, qtdFields, score) {
    this.props.sendEvaluation(form, qtdFields, score);
  }

  handleToggleMinimize = e => {
    this.props.toggleMinimize(!this.props.app.minimize);
  }

  toggleTTS = e => {
    e.stopPropagation();

    if (this.props.app.ttsActive && this.props.app.loadedTtsSound) {
      const { loadedTtsSound } = this.props.app
      loadedTtsSound.stop();
      this.props.loadedTTSSound(false);
    }

    this.props.toggleTtsActive(!this.props.app.ttsActive)
  }

  handleMsgSound = e => {
    e.stopPropagation();
    this.props.toggleMsgSound(!this.props.app.msgSoundActive)
  }

  handleTtsSound = e => {
    e.stopPropagation();
    this.props.toggleTtsActive2();
  }

  handleHighContrastMode = e => {
    if (this.props.theme === 'light') {
      this.props.changeToDarkTheme()
    }
    if (this.props.theme === 'dark') {
      this.props.changeToLightTheme()
    }
  }


  getOptions(buttonStyles) {
    if (this.userInfo.browser === "Internet Explorer" && this.userInfo.version === "11.0") return false;
    if (!this.props.app.conversation || !this.props.config.isTextToSpeechActive) return null;
    const active = this.props.app.ttsActive ? "active" : "";
    return (
      <button alt="Texto em fala" title="Texto em fala" className={active} onClick={this.toggleTTS} style={buttonStyles}>
        {this.props.app.ttsActive ? <VolumeHighIcon width={this.buttonSize} /> : <VolumeOffIcon width="10px" />}
      </button>
    );
  }

  getHeaderColors = () => {
    if (this.props.config.headerColor) {
      document.documentElement.style.setProperty('--header-color', this.props.config.headerColor);
    }
    const color = getComputedStyle(document.documentElement).getPropertyValue('--header-color');
    const header = tinycolor(color);
    return {
      color: header.getLuminance() > 0.5 ? "#333333" : "#F1f1f1"
    };
  }

  previewFile(file) {
    const reader = new FileReader();
    let preview;
    reader.readAsDataURL(file);

    reader.addEventListener("load", function () {
      preview = reader.result;
      sessionStorage.setItem('preview', preview)
    })
  }

  selectFile = e => {
    e.stopPropagation();
    return e.currentTarget.children['attachment'].click()
  }

  getAttachButton(buttonStyles) {
    return <ChatUpload buttonHeader={{ buttonStyles }} app={this.props.app} config={this.props.config} message={this.props.message} ws={this.props.ws}></ChatUpload>
  }

  render() {
    const headerStyles = this.getHeaderColors();
    const buttonStyles = {
      color: headerStyles.color
    };
    let isMobile = this.userInfo.isMobile
    let close = `close-btn-eds`;
    let volume = `volume-btn-eds`;
    let titleChat = `text-title`;
    let headerChat = `${this.props.app.minimize && isMobile ? "header-mobile" : "chat-header"}`;

    return (
      <div id="omni-header-chat" className={headerChat} style={headerStyles}>
        <div className={`${volume} title-icon`}>
          <div className="volume-icon" onClick={e => this.handleMsgSound(e)} title='Ligar ou Desligar o Alerta Sonoro de recebimento de mensagens'>
            {this.props.app.msgSoundActive ? <VolumeHighIcon width={this.buttonSize} height={this.buttonSize2} /> :
              <VolumeOffIcon width={"10px"} height={this.buttonSize2} />}
          </div>
          <div className="volume-icon" onClick={e => this.handleTtsSound(e)} title='Ativar ou Desativar o TTS' style={{"margin-left": "3px", }}>
            {this.props.app.ttsActive2 ? <img src={textSpeech} alt="Leitor de textos" width="16px"/> :
                <img src={notTextSpeech} alt="Sem leitor de textos" width="16px"/>
            }
          </div>
          {this.props.config.isEnableHighContrastMode &&
            <div className="volume-icon" onClick={e => this.handleHighContrastMode(e)} title='Ativar ou Desativar o Alto Contraste' >
              <CircleHalfStroke width={this.buttonSize} />
            </div>
          }

        </div>

        <div className={titleChat}>{"Chat"}</div>
        <div className="actions">

          {this.props.app.websocket && this.props.app.attachAvailable ? this.getAttachButton(buttonStyles) : false}

          {this.getOptions(buttonStyles)}
          <button id="omni-max-chat" className="minimize-btn-eds" alt="Minimizar" title="Minimizar" onClick={e => this.handleToggleMinimize()} style={buttonStyles}>
            {this.props.app.minimize ? <AngleUpIcon width="12px" /> : <AngleDownIcon width="12px" />}
          </button>
          <button className={close} alt="Fechar" title="Fechar" onClick={this.handleClose} style={buttonStyles}>
            <XMarkIcon width="10px" />
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  messages: state.messages,
  app: state.app,
  config: state.config,
  conversation: state.conversation,
  theme: state.theme
});

const mapDispatchToProps = dispatch => ({
  toggleAttachAvailable: status => dispatch(toggleAttachAvailable(status)),
  toggleAllowAttachment: status => dispatch(toggleAllowAttachment(status)),
  toggleMinimize: toggle => dispatch(toggleMinimize(toggle)),
  toggleOptions: toggle => dispatch(toggleOptions(toggle)),
  toggleTtsActive: toggle => dispatch(toggleTtsActive(toggle)),
  toggleTtsActive2: () => dispatch(toggleTtsActive2()),
  toggleMsgSound: toggle => dispatch(toggleMsgSound(toggle)),
  loadedTTSSound: sound => dispatch(loadedTTSSound(sound)),
  toggleModal: (toggle, message, onConfirm, onClose) => dispatch(toggleModal(toggle, message, onConfirm, onClose)),
  sendEvaluation: (form, qtdFields, score) => dispatch(sendEvaluation(form, qtdFields, score)),
  sendMessage: (message, from) => dispatch(sendMessage(message, from)),
  toggleAttachLoad: status => dispatch(toggleAttachLoad(status)),
  closeChat: () => {
    dispatch(toggleChat(false))
    dispatch(closeConversation())
  },
  changeToLightTheme: () => dispatch(changeToLightTheme()),
  changeToDarkTheme: () => dispatch(changeToDarkTheme())
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatHeader);
